import React, { useState } from "react";
import logo from "../assets/images/Latestlogo.png";

import { NavLink } from "react-router-dom";
import IdleTimer from "./IdleTimer";
import SessionTimeoutDialog from "./SessionTimeoutDialog";
import { getUserPermissions } from "../utils/permissions";
import {
  IoIosArrowForward,
  IoIosArrowBack,
} from "react-icons/io";

function Sidebar() {
  const [showTimeoutDialog, setShowTimeoutDialog] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const permissions = getUserPermissions();

  const handleIdle = () => {
    setShowTimeoutDialog(true);
  };

  const handleLogout = () => {
    setShowTimeoutDialog(false);
    localStorage.clear();

    alert("Session expired due to inactivity");

    window.location.href = "/login";
  };

  /* =========================================================
     COMPACT MENU STYLE
  ========================================================= */
  const menuClass = ({ isActive }) => `
    group
    relative
    flex
    w-full
    min-h-[42px]
    items-center
    gap-2
    rounded-lg
    border
    ${collapsed ? "justify-center px-1" : "px-2 py-1"}
    overflow-hidden
    transition-all
    duration-200

    ${
      isActive
        ? `
          border-cyan-200
          bg-cyan-50
          text-[#07111f]
          shadow-[0_4px_12px_rgba(14,165,233,0.08)]
        `
        : `
          border-transparent
          text-[#07111f]
          hover:border-cyan-100
          hover:bg-slate-50
          hover:text-cyan-700
        `
    }
  `;

  return (
    <>
      {/* =====================================================
          IDLE TIMER
      ===================================================== */}
      <IdleTimer onTimeout={handleIdle} />

      {/* =====================================================
          SESSION TIMEOUT
      ===================================================== */}
      <SessionTimeoutDialog
        isOpen={showTimeoutDialog}
        onLogout={handleLogout}
      />

      {/* =====================================================
          SIDEBAR
      ===================================================== */}
      <aside
        className={`
          relative
          z-50
          hidden
          h-screen
          max-h-screen
          shrink-0
          flex-col
          overflow-hidden
          border-r
          border-slate-200
          bg-white
          text-[#07111f]
          shadow-[6px_0_25px_rgba(0,0,0,0.06)]
          transition-all
          duration-300
          md:flex

          ${collapsed ? "w-[68px]" : "w-[265px]"}
        `}
      >

        {/* ===================================================
            HEADER
        =================================================== */}
        <div
          className="
            relative
            flex
            h-[82px]
            min-h-[82px]
            w-full
            shrink-0
            items-center
            justify-center
            border-b
            border-slate-200
            bg-white
          "
        >
          {/* Logo */}
          <div className="flex items-center justify-center">
            <img
              src={logo}
              alt="MIM"
              className="
                h-[72px]
                w-[145px]
                object-contain
              "
            />
          </div>

          {/* Collapse Button */}
          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            aria-label="Toggle sidebar"
            className="
              absolute
              right-2
              top-2
              flex
              h-6
              w-6
              items-center
              justify-center
              rounded-full
              border
              border-slate-200
              bg-white
              text-[#07111f]
              shadow-sm
              transition-all
              hover:border-cyan-200
              hover:bg-cyan-50
              hover:text-cyan-600
            "
          >
            <span
              className="
                flex
                items-center
                justify-center
                text-sm
                leading-none
              "
            >
              {collapsed ? (
                <IoIosArrowForward />
              ) : (
                <IoIosArrowBack />
              )}
            </span>
          </button>
        </div>

        {/* ===================================================
            CONTENT
            NO SCROLL
        =================================================== */}
        <div
          className="
            relative
            flex-1
            min-h-0
            overflow-hidden
            bg-white
            px-2
            py-2
          "
        >
          <nav className="space-y-2">

            {/* =================================================
                SMS SECTION
            ================================================= */}
            {permissions.sms && (
              <div>

                {/* SMS Heading */}
                {!collapsed && (
                  <div
                    className="
                      mb-1
                      flex
                      h-5
                      items-center
                      gap-1.5
                      px-1.5
                    "
                  >
                    <div
                      className="
                        h-4
                        w-0.5
                        shrink-0
                        rounded-full
                        bg-[#07111f]
                      "
                    />

                    <span
                      className="
                        text-[10px]
                        font-extrabold
                        uppercase
                        leading-none
                        tracking-[0.14em]
                        text-[#07111f]
                      "
                    >
                      SMS Pages
                    </span>
                  </div>
                )}

                <div className="space-y-0.5">

                  {/* Check Mobile Number */}
                  <NavLink
                    to="/number"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Check Mobile Number"
                        : ""
                    }
                  >
                    <MenuIcon icon="📱" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Check Mobile Number
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Template Wise Report */}
                  <NavLink
                    to="/template"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Template Wise Report"
                        : ""
                    }
                  >
                    <MenuIcon icon="📄" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Template Wise Report
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Traffic Summary */}
                  <NavLink
                    to="/traffic"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Traffic Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📊" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Traffic Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Failure Analysis */}
                  <NavLink
                    to="/failure"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Failure Analysis"
                        : ""
                    }
                  >
                    <MenuIcon icon="⚠️" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Failure Analysis
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                </div>
              </div>
            )}

            {/* =================================================
                EMAIL SECTION
            ================================================= */}
            {permissions.email && (
              <div>

                {/* Email Heading */}
                {!collapsed && (
                  <div
                    className="
                      mb-1
                      flex
                      h-5
                      items-center
                      gap-1.5
                      px-1.5
                    "
                  >
                    <div
                      className="
                        h-4
                        w-0.5
                        shrink-0
                        rounded-full
                        bg-[#07111f]
                      "
                    />

                    <span
                      className="
                        text-[10px]
                        font-extrabold
                        uppercase
                        leading-none
                        tracking-[0.14em]
                        text-[#07111f]
                      "
                    >
                      Email Pages
                    </span>
                  </div>
                )}

                <div className="space-y-0.5">

                  {/* Email Monitoring */}
                  <NavLink
                    to="/email-monitoring"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Monitoring"
                        : ""
                    }
                  >
                    <MenuIcon icon="✉️" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Email Monitoring
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Email Subject Wise Summary */}
                  <NavLink
                    to="/emailSubjectWiseReport"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Subject Wise Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📑" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[10.5px]
                            font-semibold
                            leading-none
                          "
                        >
                          Email Subject Wise Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Email Summary */}
                  <NavLink
                    to="/emailSummary"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📈" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[12px]
                            font-semibold
                            leading-none
                          "
                        >
                          Email Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                </div>
              </div>
            )}
          </nav>
        </div>

        {/* ===================================================
            FOOTER
        =================================================== */}
        <div
          className="
            relative
            flex
            min-h-[42px]
            shrink-0
            items-center
            justify-center
            border-t
            border-slate-200
            bg-white
            px-2
          "
        >
          {!collapsed ? (
            <div className="flex flex-col items-center justify-center">

              <p
                className="
                  text-[6px]
                  font-bold
                  uppercase
                  leading-none
                  tracking-[0.2em]
                  text-slate-400
                "
              >
                Powered By
              </p>

              <p
                className="
                  mt-1
                  text-[9px]
                  font-bold
                  leading-none
                  tracking-wide
                  text-[#07111f]
                "
              >
                MyInboxMedia
              </p>

            </div>
          ) : (
            <div
              className="
                h-2
                w-2
                rounded-full
                bg-[#07111f]
              "
            />
          )}
        </div>
      </aside>
    </>
  );
}

/* =========================================================
   MENU ICON
========================================================= */
function MenuIcon({ icon }) {
  return (
    <div
      className="
        flex
        h-[30px]
        w-[30px]
        shrink-0
        items-center
        justify-center
        rounded-lg
        border
        border-slate-200
        bg-slate-50
        text-[14px]
        leading-none
        transition-all
        duration-200
        group-hover:border-cyan-200
        group-hover:bg-cyan-50
      "
    >
      <span className="flex items-center justify-center leading-none">
        {icon}
      </span>
    </div>
  );
}

/* =========================================================
   ARROW
========================================================= */
function ArrowIcon() {
  return (
    <span
      className="
        flex
        h-4
        w-4
        shrink-0
        items-center
        justify-center
        text-[12px]
        font-bold
        leading-none
        text-slate-400
        transition-all
        duration-200
        group-hover:translate-x-0.5
        group-hover:text-cyan-600
      "
    >
      →
    </span>
  );
}

export default Sidebar;